var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHelp24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5a.75.75 0 100-1.5.75.75 0 000 1.5zm-2.5-5.985a.5.5 0 00.5-.5c0-.672.7-1.515 2-1.515s2 .834 2 1.5c0 .764-.456.99-.932 1.226L13 11.26c-.039.02-.08.04-.124.06-.524.255-1.371.665-1.371 1.68v.5a.5.5 0 001 0V13c0-.201.069-.317.209-.433.151-.126.348-.223.62-.356l.142-.07c.314-.156.703-.361 1.007-.693.322-.352.522-.815.522-1.433 0-1.359-1.297-2.515-3-2.515C10.303 7.5 9 8.655 9 10.015a.5.5 0 00.5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12a8.5 8.5 0 1117 0 8.5 8.5 0 01-17 0zM12 4.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp24);
export default __webpack_public_path__ + "static/media/icon-help-24.5e343130.svg";
export { ForwardRef as ReactComponent };